module.exports = __webpack_public_path__ + "static/media/fi-rr-clock.d671214a.svg";